'use client';

import React, { useState, useEffect } from 'react';
import blogAPI from '@/services/blogAPI'; // Correct import path

const TravelBlog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const fetchBlogPosts = async () => {
    try {
      setLoading(true);
      const response = await blogAPI.getPublishedBlogPosts({ limit: 3 });
      setBlogPosts(response.blogPosts || []);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching blog posts:', err);
      setError('Failed to fetch blog posts');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Travel Blog</h2>
          <p className="text-lg text-gray-600 mb-12">Loading blog posts...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Travel Blog</h2>
          <p className="text-lg text-red-600 mb-12">Error: {error}</p>
          <button 
            onClick={fetchBlogPosts}
            className="bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 px-4 rounded-md transition duration-300"
          >
            Retry
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">Travel Blog</h2>
        <p className="text-base md:text-lg text-gray-600 mb-8 md:mb-12">Read our latest travel stories and discover new adventures</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <div key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105">
              {post.imageUrl ? (
                <img 
                  src={`${process.env.NEXT_PUBLIC_API_URL?.replace('/api', '') || 'http://localhost:5000'}${post.imageUrl}`} 
                  alt={post.title}
                  className="w-full h-48 object-cover"
                />
              ) : (
                <div className="w-full h-48 bg-gray-200 flex items-center justify-center">
                  <span className="text-gray-500">No Image</span>
                </div>
              )}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{post.title}</h3>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <a 
                  href={`/blog/${post.slug}`} 
                  className="bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 px-4 rounded-md transition duration-300 inline-block"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TravelBlog;